import actions from './actions'
import mutations from './mutations'

const Agenda = {
  state: () => ({
    agenda: [],
    currentDay: new Date().toString(),
    dateRange: false,
    loading: false
  }),
  getters: {
    agenda: state => state.agenda,
    currentDay: state => state.currentDay,
    dateRange: state => state.dateRange,
    loading: state => state.loading
  },
  mutations,
  actions,
}

export default Agenda
